import React from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets';
import { ScreenEvent } from '@confluence/analytics/entry-points/ScreenEvent';

import type { SpaceSelection } from '../page-components/SpaceSelectionRadioButtons';

import { LoadingDialog } from './LoadingDialog';
import { ConfirmationDialog } from './ConfirmationDialog';

export const BulkSpacePermissionsModal = ({
	principalName,
	isLoading,
	isRemoval,
	spaceSelection,
	onCancel,
	onConfirm,
}: {
	principalName: string;
	isLoading: boolean;
	isRemoval: boolean;
	spaceSelection: SpaceSelection;
	onCancel: () => void;
	onConfirm: () => void;
}) => {
	const { Modal } = useChoreographerAssets();

	return (
		<ModalTransition>
			<ScreenEvent
				name="bulk-space-permissions-dialog"
				id="bulk-space-permissions-dialog"
				attributes={isRemoval ? { action: 'remove' } : { action: 'add' }}
			/>
			<Modal
				testId="bulk-space-permissions-confirmation"
				onClose={
					// Don't allow the dialog to close while mutation is loading
					isLoading ? undefined : onCancel
				}
			>
				{isLoading ? (
					<LoadingDialog />
				) : (
					<ConfirmationDialog
						principalName={principalName}
						isRemoval={isRemoval}
						spaceSelection={spaceSelection}
						onCancel={onCancel}
						onConfirm={onConfirm}
					/>
				)}
			</Modal>
		</ModalTransition>
	);
};
